!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.hero = {
    attach: function(context) {
      let breadcrumbsElement = $(
        '.layout-container #block-cbg-theme-2024-breadcrumbs',
        context
      ).first();
      let hero = $(
        '.layout-container #block-cbg-theme-2024-content .block.block--hero',
        context
      ).first();
      let isInLayoutView = $('#layout-builder', context);

      // Move the breadcrumbs below the hero if hero block exists
      if (
        breadcrumbsElement.length > 0 &&
        hero.length > 0 &&
        isInLayoutView.length <= 0
      ) {
        breadcrumbsElement.insertAfter(hero);
      }
    }
  };
})(Drupal, jQuery);
